import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";

/**
 * Opens an external URL in the system browser.
 * Uses Capacitor Browser plugin on native platforms, falls back to window.open on web/PWA.
 *
 * @param url - The URL to open
 * @param options - Optional browser options
 */
export async function openExternalUrl(
  url: string,
  options?: {
    windowName?: string;
    windowFeatures?: string;
  },
): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    // Use Capacitor Browser plugin for native apps (Android/iOS)
    await Browser.open({ url });
  } else {
    // Use window.open for web/PWA
    window.open(url, options?.windowName || "_blank", options?.windowFeatures);
  }
}
